import React from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";

import { opcionesDeArbol } from "../../utils/categorias";

/**
 * Selector múltiple de categorías para barras de filtros, sobre el árbol de
 * `grupos?arbol=1`. El menú se indenta por nivel y el texto buscable es la ruta
 * completa, así que escribir el nombre del padre encuentra sus subcategorías.
 *
 * Para asignar categorías a un producto se usa CategoriasCheckboxTree, que además
 * maneja la categoría principal y el alta de categorías nuevas.
 */
const CategoriasSelect = ({
	arbol = [],
	valor = [],
	onChange,
	isDisabled = false,
	inputId = "categorias",
	placeholder = "Seleccionar categorías...",
}) => {
	const opciones = opcionesDeArbol(arbol);

	const seleccionadas = valor
		.map((id) => opciones.find((opcion) => opcion.value === id))
		.filter(Boolean);

	return (
		<ReactSelect
			isMulti
			isClearable
			inputId={inputId}
			options={opciones}
			value={seleccionadas}
			onChange={(elegidas) =>
				onChange((elegidas || []).map((opcion) => opcion.value))
			}
			isDisabled={isDisabled}
			placeholder={placeholder}
			noOptionsMessage={() => "No hay categorías"}
			closeMenuOnSelect={false}
			formatOptionLabel={(opcion, { context }) =>
				context === "menu" ? (
					<span style={{ paddingLeft: `${opcion.nivel * 18}px` }}>
						{opcion.nivel > 0 && <span className="text-muted">&mdash; </span>}{/* emdash */}
						{opcion.nombre}
					</span>
				) : (
					opcion.ruta
				)
			}
		/>
	);
};

CategoriasSelect.propTypes = {
	arbol: PropTypes.array,
	valor: PropTypes.array,
	onChange: PropTypes.func.isRequired,
	isDisabled: PropTypes.bool,
	inputId: PropTypes.string,
	placeholder: PropTypes.string,
};

export default CategoriasSelect;
